<div class="fixed top-5 right-5 z-[50000] space-y-2 alert-container">
  <div *ngFor="let alert of notificationService.message; let i = index; trackBy: trackById"
       [ngClass]="{
         'translate-x-0 opacity-100': alert.visible,
         'translate-x-full opacity-0': !alert.visible,
         'bg-green-100 text-green-800 border-green-400': alert.type === 'success',
         'bg-red-100 text-red-800 border-red-400': alert.type === 'danger',
         'bg-amber-100 text-amber-800 border-amber-400': alert.type === 'warning',
         'bg-blue-100 text-blue-800 border-blue-400': alert.type === 'info'
       }"
       class="min-w-[300px] w-full p-4 rounded-lg shadow-lg pointer-events-auto transition ease-in-out duration-300 transform"
       [ngStyle]="{ transition: 'all 0.3s ease-in-out' }">
    <div class="flex items-start">
      <div class="ml-3 w-0 flex-1">
        <p class="text-sm font-medium whitespace-pre-line">{{ alert.msg }}</p>
      </div>
      <div class="ml-4 flex-shrink-0">
        <button (click)="handleOnClose(alert)" class="text-gray-400 hover:text-gray-500 focus:outline-none">
          <span class="sr-only">Close</span>
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
